import { mockOutlets } from '../../../redux/customers/customerReference';

// Outlets, menu items and the other reference lists are shared with the Customers module.
export {
  DAYPART_OPTIONS, ORDER_CHANNEL_OPTIONS, mockCategories, mockItems, mockOutlets, mockTiers, mulberry32,
} from '../../../redux/customers/customerReference';

export const MOCK_BRAND_ID = 'brand_a2b';

/**
 * Mock customers are tied to the mock outlets, not to the portal's real outlets.
 * A campaign saved against a real outlet is treated as covering all mock customers.
 */
export function knownMockOutletIds(outletIds: string[]): string[] {
  return outletIds.filter((id) => mockOutlets.some((o) => o.id === id));
}

export function hashSeed(text: string): number {
  let h = 2166136261;
  for (let i = 0; i < text.length; i += 1) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
